import React, {Component} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import Util from '../../../forecast-app/shared/util/util';
import MarkTimeLogTimeRegsForRetry from '../../../mutations/mark_timelog_timeregs_for_retry';

class TimeLogErrorView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			handledOrUnhandled: '',
			selectedErrors: [],
			selectAll: false,
		};
	}

	resolve() {
		const onSuccess = () => {
			this.props.close();
		};
		Util.CommitMutation(
			MarkTimeLogTimeRegsForRetry,
			{
				timeRegs: this.state.selectedErrors,
			},
			onSuccess
		);
	}

	closeModal() {
		this.props.close();
	}

	handleSelectAllErrors() {
		const selected = [];
		if (!this.state.selectAll) {
			this.props.errors.edges
				.filter(e => !e.node.timeLogMarkedForRetry)
				.forEach(e => {
					selected.push(e.node.id);
				});
		}
		this.setState({selectedErrors: selected, selectAll: !this.state.selectAll});
	}

	handleSelectTimeReg(id) {
		const selected = this.state.selectedErrors;
		if (this.state.selectedErrors.includes(id)) {
			const index = selected.indexOf(id);
			selected.splice(index, 1);
		} else {
			selected.push(id);
		}
		this.setState({selectedErrors: selected});
	}

	render() {
		return (
			<div className="layer">
				<div className="fullscreen fullscreen-centered-outer timelog-errors">
					<div className="fullscreen-centered-inner">
						<div className="fullscreen-centered-content">
							<h1>Tidsregistreringer som ikke kan sendes til TimeLog</h1>
							<h3>
								{"Nedenstående tidsregistreringer bliver afvist af TimeLog med den fejl som står i 'Fejl'-kolonnen. " +
									'Når du har løst problemerne i TimeLog kan du tjekke tidsregistreringerne af i højre side af tabellen. Herefter ' +
									'vil vi forsøge at sende dem til TimeLog igen næste gang TimeLog integrationsn kører.'}
							</h3>
							<h3>
								{
									'Hvis en checkbox er grå/disabled er det fordi tidsregistreringen allerede er markeret som løst. Den vil således være grå/disabled indtil integrationen er kørt igen.'
								}
							</h3>
							<table className="timelog-table">
								<thead>
									<tr>
										<th>Projekt</th>
										<th>Opgave</th>
										<th>Person</th>
										<th>Tid</th>
										<th>Dato</th>
										<th>Noter</th>
										<th>Fejl</th>
										<th>
											<input
												value={this.state.selectAll}
												type="checkbox"
												onChange={this.handleSelectAllErrors.bind(this)}
											/>
										</th>
									</tr>
								</thead>
								<tbody>
									{this.props.errors.edges.map((error, index) => {
										const e = error.node;
										return (
											<tr className="time-reg-line-item" key={'economic-time-reg-line-' + index}>
												<td className={'field'}>{e.task.project.name}</td>
												<td className={'field'}>{e.task.name}</td>
												<td className={'field'}>{e.person.firstName + ' ' + e.person.lastName}</td>
												<td className={'field-nowrap'}>
													<FormattedMessage
														defaultMessage="{hours, number} h"
														values={{hours: e.minutesRegistered / 60}}
														id="common.x_hours"
													/>
												</td>
												<td className={'field-nowrap'}>
													{Util.CreateMomentDate(e.year, e.month, e.day).format(
														this.props.viewer.language === 'ENGLISH_US'
															? 'MM/DD/YYYY'
															: 'DD/MM/YYYY'
													)}
												</td>
												<td className={'field-elipse'} title={e.notes}>
													{e.notes}
												</td>
												<td className={'field'}>{e.timeLogErrorText}</td>
												<td>
													<input
														disabled={e.timeLogMarkedForRetry}
														checked={
															this.state.selectedErrors.some(t => t === e.id) ||
															e.timeLogMarkedForRetry
														}
														type="checkbox"
														onChange={this.handleSelectTimeReg.bind(this, e.id)}
													/>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
							<div>
								<button className="timelog-button" onClick={this.closeModal.bind(this)} disabled={false}>
									Luk
								</button>
								<button
									className="timelog-button"
									onClick={this.resolve.bind(this)}
									disabled={this.state.selectedErrors.length === 0}
								>
									Løst
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default injectIntl(TimeLogErrorView);
